import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthenticationFacade } from './store/authentication/authentication.facade';
import { Subscription, tap } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import defaultLanguage from '../assets/i18n/de.json';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DateUtilsService } from './services/core/date-utils.service';
import de from 'dayjs/locale/de';
import { Title } from '@angular/platform-browser';
import { CustomizationFacade } from './store/customization/customization.facade';
import { NavShareService } from './services/core/nav-share.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [MessageService]
})
export class AppComponent implements OnInit, OnDestroy {
    translate$: Subscription = new Subscription();

    constructor(
        private authenticationFacade: AuthenticationFacade,
        private config: PrimeNGConfig,
        private translate: TranslateService,
        private dateUtilsService: DateUtilsService,
        private titleService: Title,
        private customizationFacade: CustomizationFacade,
        private navShareService: NavShareService
    ) {
        this.titleService.setTitle('SkedFlex | schedule flexible');
        this.translate.setTranslation('de', defaultLanguage);
        this.dateUtilsService.setLocale(de);
        this.translate$ = this.translate.get('primeng').subscribe((res) => this.config.setTranslation(res));
    }

    user$ = this.authenticationFacade.user$;
    collapsed$ = this.navShareService.sidebarCollapsed$;

    ngOnInit(): void {
        this.customizationFacade.customization$
            .pipe(
                tap((customization) => {
                    const theme = customization?.customized ? customization?.tenantIdentifier : 'skedflex';
                    document.body.setAttribute('data-theme', theme);
                })
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.translate$.unsubscribe();
    }
}
